// extracted by mini-css-extract-plugin
export default {"btn-custom":"customButton_btn-custom__3Q+lb","btn-custom-outlet":"customButton_btn-custom-outlet__1-m5z","btn-custom-no-border":"customButton_btn-custom-no-border__wBLdh"};